var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0913 9.11928C26.1475 15.3059 22.6919 21.9705 16.409 23.9671C10.1262 25.9918 3.35778 22.5892 1.33013 16.4026C-0.726087 10.216 2.7295 3.55133 9.01238 1.55474C10.2118 1.16105 11.4684 0.964203 12.725 0.964203C17.8941 0.992324 22.492 4.28247 24.0913 9.11928ZM12.725 2.06092C6.69914 2.06092 1.84418 6.8696 1.84418 12.8031C1.84418 18.7366 6.72769 23.5172 12.7535 23.5172C18.7794 23.5172 23.6343 18.7085 23.6343 12.775C23.6343 11.6502 23.463 10.5534 23.0917 9.48485C21.6353 5.04174 17.4371 2.0328 12.725 2.06092Z",
    fill: "#4D77AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6669 8.72666C15.0667 8.72666 15.4665 8.72666 15.8378 8.72666H16.0091V6.72984C15.8092 6.72984 15.5808 6.67358 15.3523 6.67358C14.9525 6.67358 14.5527 6.67358 14.1528 6.67358C13.5531 6.67358 12.9534 6.84233 12.4679 7.17982C11.9253 7.57357 11.554 8.1923 11.4683 8.83916C11.4112 9.09228 11.3827 9.37352 11.3827 9.62664C11.3827 10.0766 11.3827 10.5266 11.3827 10.9766V11.2016H9.44067V13.4234H11.3541V19.0202H13.753V13.3953H15.6664L15.8949 11.1735H13.6673C13.6673 11.1735 13.6673 10.0766 13.6673 9.59852C13.753 8.92354 14.1528 8.72666 14.6669 8.72666Z",
    fill: "#4D77AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.4b7c4b609038e1b0aea4bc587664da5f.svg";
export { ForwardRef as ReactComponent };